import _hasOwnProperty from "../internals/has-own-property";
var exports = {};
var hasOwn = _hasOwnProperty;
exports = function (descriptor) {
  return descriptor !== undefined && (hasOwn(descriptor, "value") || hasOwn(descriptor, "writable"));
};
export default exports;